export default __webpack_public_path__ + "wpseoai.css";